/* unplugin-vue-components disabled */import { render } from "./icon_heart.vue?vue&type=template&id=9927f8e4&scoped=true"
const script = {}

import "./icon_heart.vue?vue&type=style&index=0&id=9927f8e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9927f8e4"]])

export default __exports__